<button
    (click)="op.toggle($event)"
    [ngClass]="{
        'is-visible-datepicker': op.overlayVisible && false,
        'is-active': _value
    }"
    class="datepicker"
>
    <span class="label">
        {{label}}
        <ng-container *ngIf="selectionMode === 'single' && _value">
            | {{ _value | date: 'mediumDate' : '' : langauge }}
        </ng-container>
        <ng-container *ngIf="selectionMode === 'range' && _value?.length">
            | {{ _value[0] | date: 'mediumDate' : '' : langauge }}
            <ng-container *ngIf="_value[1]">
                - {{ _value[1] | date: 'mediumDate' : '' : langauge }}
            </ng-container>
        </ng-container>
    </span>
    <button class="toggle-btn">
        <i class="pi pi-chevron-down icon"></i>
    </button>
</button>

<p-popover #op>
    <div class="datepicker-popover">
        <p-datepicker
            [(ngModel)]="_value"
            (ngModelChange)="onDateChange($event, op);"
            [maxDate]="maxDate"
            [inline]="true"
            [selectionMode]="selectionMode"
            [firstDayOfWeek]="1"
            class="max-w-full"
        ></p-datepicker>

        <div
            *ngIf="maxSelectableDays"
            class="datepicker-popover__max-options-selected"
        >
            <span class="datepicker-popover__max-options-selected__title">
                <i class="pi pi-info-circle icon"></i>
                {{'theMaximumDataRangeIs'|translate}} {{ maxSelectableDays }} {{ maxSelectableDays === 1 ? ('date-time.day' | translate) : ('date-time.days' | translate) }}
            </span>
        </div>

        <p-button
            (onClick)="onDateChange($any(null), op); op.hide()"
            [label]="'labels.clear' | translate"
            variant="text"
            severity="danger"
            class="clear-btn"
        />
    </div>
</p-popover>
